module.exports = __webpack_public_path__ + "static/media/boca-photo-5.34ad5aa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/boca-photo-5.jpg
// module id = 2086
// module chunks = 0